// Smooth scroll to element on page load if hash exists in URL
console.log('anchor-links.js loaded');
document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1); // Remove '#' from the hash
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      setTimeout(() => scrollToTarget(targetElement), 0); // Delay to ensure DOM is ready
    }
  }
});

// Smooth scroll to clicked anchor link
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const targetUrl = this.getAttribute('href');
    console.log('targetUrl', targetUrl);
    if (isSamePageAnchor(targetUrl)) {
      e.preventDefault(); // Prevent default anchor behavior

      const targetId = targetUrl.substring(targetUrl.indexOf('#') + 1);
      console.log('targetId', targetId);
      const targetElement = document.getElementById(targetId);
      console.log('targetElement', targetElement);

      if (targetElement) {
        scrollToTarget(targetElement);
      }
    }

    // Optionally, close the menu if it's a navigation link
    console.log('this.classList', this.classList);
    const $menuItemClasses = ['nav-link', 'dropdown-item'];
    if ($menuItemClasses.some(className => this.classList.contains(className))) {
      collapseMenu();
    }
  });
});

// Function to scroll to target element smoothly
function scrollToTarget(target) {
  target.scrollIntoView({ behavior: 'smooth' });
}

// Function to check if the anchor is on the same page
function isSamePageAnchor(anchorUrl) {
  const normalizeUrl = (url) => url.replace(/\/$/, '');
  const currentPageUrl = normalizeUrl(window.location.href.split('#')[0]);
  console.log('currentPageUrl', currentPageUrl);
  const targetPageUrl = normalizeUrl(anchorUrl.split('#')[0]);
  console.log('targetPageUrl', targetPageUrl);
  return currentPageUrl === targetPageUrl;
}



// Function to collapse the menu
function collapseMenu() {
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.getElementById('navbarMobile')
  document.querySelector('body').classList.remove('menu-active');
  mobileMenu.classList.remove('show');
  hamburger.classList.remove('is-active');
  hamburger.classList.add('collapsed');
  hamburger.setAttribute('aria-expanded', 'false');
}
